import translation from 'translation';

const { t } = translation;

export const getToOneMonthDuration = () => {
  return [
    {
      key: t('common:today'),
      time_duration: 'today',
    },
    {
      key: t('common:lastSixHours'),
      time_duration: '6h',
    },
    {
      key: t('common:last24Hours'),
      time_duration: '24h',
    },
    {
      key: t('common:lastWeek'),
      time_duration: '1w',
    },
    {
      key: t('common:lastTwoWeeks'),
      time_duration: '2w',
    },
    {
      key: t('common:lastMonth'),
      time_duration: '1m',
    },
  ];
};

export const getMoreThanOneMonthDurations = () => {
  return [
    {
      key: t('common:lastThreeMonth'),
      time_duration: '3m',
    },
    {
      key: t('common:lastSixMonth'),
      time_duration: '6m',
    },
    {
      key: t('common:lastYear'),
      time_duration: '12m',
    },
  ];
};

export const getLessThanOneDayDurationsFiltered = () => {
  return getToOneMonthDuration().filter((d) => {
    return !['today', '6h', '24h'].includes(d.time_duration);
  });
};
